import { toNorwegianDate } from '../utils/date';
import { getEnv } from '../utils/env';

export const removeError = () => ({
    type: 'REMOVE_ERROR',
});

export const setError = (error) => ({
    type: 'SET_ERROR',
    error: error,
});

export const removeInformation = () => ({
    type: 'REMOVE_INFORMATION',
});

export const setInformation = (information) => ({
    type: 'SET_INFORMATION',
    information: information,
});

export const removeWarning = () => ({
    type: 'REMOVE_WARNING',
});

export const setWarning = (warning) => ({
    type: 'SET_WARNING',
    warning: warning,
});

export const removeAnnouncement = () => ({
    type: 'REMOVE_ANNOUNCEMENT',
});

export const setAnnouncement = (announcement, announcementPeriod) => ({
    type: 'SET_ANNOUNCEMENT',
    announcement: announcement,
    announcementPeriod: announcementPeriod,
});

export const loadAnnouncement = () => (dispatch) => {
    fetch(`${getEnv('API_URL')}/service/announcements/current`, {
        method: 'GET',
        credentials: 'include',
    })
        .then((response) => response.json())
        .then((data) => {
            dispatch(
                setAnnouncement(
                    'OBS: ' + data.message,
                    `${toNorwegianDate(data.validFrom)} - ${toNorwegianDate(data.validTo)}`,
                ),
            );
            return data;
        })
        .catch((error) => {
            return error;
        });
};
